/**
 * Login
 */
export const Login = (function () {
    var init =  function () {  
        var form = document.getElementById('user-login-form');
        var button = document.getElementById('edit-submit');

        if (form && button) {
            form.addEventListener('submit', function () {
                button.disabled = true;
                button.innerText = 'Logging in...';
            });
        }

        // These are for the MFA setup screen
        var copyButton = document.getElementById('copyButton');
        var printButton = document.getElementById('printButton');
        var backupCodesTable = document.getElementById('backup-codes-table');

        if (backupCodesTable) {
            // Function to copy table content to clipboard
            copyButton.addEventListener('click', () => {
                // Create a temporary textarea to hold the table content
                const textarea = document.createElement('textarea');
                textarea.value = backupCodesTable.innerText; // Copy the text content of the table
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
                const originalText = copyButton.innerText; // Store the original text
                copyButton.innerText = 'Copied to clipboard!'; // Change to the new text
                setTimeout(() => {
                    copyButton.innerText = originalText; // Revert to the original text
                }, 5000); // 5000 milliseconds = 5 seconds
            });

            // Function to print the table
            printButton.addEventListener('click', () => {
                const printWindow = window.open('', '', 'height=600,width=800');
                printWindow.document.write('<html><head><title>My MydexID backup codes</title>');
                printWindow.document.write('</head><body >');
                printWindow.document.write(backupCodesTable.outerHTML); // Print the table HTML
                printWindow.document.write('</body></html>');
                printWindow.document.close();
                printWindow.focus();
                printWindow.print();
            });
        }

        // When entering in one-time codes
        var lacaConfirmForm = document.getElementById('form-laca-mfa-confirm');
        var lacaConfirmButton = document.getElementById('button-laca-mfa-confirm');
        if (lacaConfirmForm && lacaConfirmButton) {
            lacaConfirmForm.addEventListener('submit', function () {
                lacaConfirmButton.disabled = true;
                lacaConfirmButton.innerText = 'Verifying...';
            });
        }
        var lacaResendForm = document.getElementById('form-laca-mfa-resend');
        var lacaResendButton = document.getElementById('button-laca-mfa-resend');
        if (lacaResendForm && lacaResendButton) {
            lacaResendForm.addEventListener('submit', function () {
                lacaResendButton.disabled = true;
                lacaResendButton.innerText = 'Resending...';
            });
        }
        // When adding devices on setup page
        var mfaSetupTotpAddForm = document.getElementById('mfa-totp-add');
        var mfaSetupTotpAddButton = document.getElementById('button-mfa-totp-add');
        if (mfaSetupTotpAddForm && mfaSetupTotpAddButton) {
            mfaSetupTotpAddForm.addEventListener('submit', function () {
                mfaSetupTotpAddButton.disabled = true;
                mfaSetupTotpAddButton.innerText = 'Adding...';
            });
        }
        var mfaSetupEmailAddForm = document.getElementById('mfa-email-add');
        var mfaSetupEmailAddButton = document.getElementById('button-mfa-email-add');
        if (mfaSetupEmailAddForm && mfaSetupEmailAddButton) {
            mfaSetupEmailAddForm.addEventListener('submit', function () {
                mfaSetupEmailAddButton.disabled = true;
                mfaSetupEmailAddButton.innerText = 'Adding...';
            });
        }
        var mfaSetupSmsAddForm = document.getElementById('mfa-sms-add');
        var mfaSetupSmsAddButton = document.getElementById('button-mfa-sms-add');
        if (mfaSetupSmsAddForm && mfaSetupSmsAddButton) {
            mfaSetupSmsAddForm.addEventListener('submit', function () {
                mfaSetupSmsAddButton.disabled = true;
                mfaSetupSmsAddButton.innerText = 'Adding...';
            });
        }
        // Disable skip button when pressed
        var mfaSetupSkipForm = document.getElementById('mfa-skip');
        var mfaSetupSkipButton = document.getElementById('button-mfa-skip');
        if (mfaSetupSkipForm && mfaSetupSkipButton) {
            mfaSetupSkipForm.addEventListener('submit', function () {
                mfaSetupSkipButton.disabled = true;
                mfaSetupSkipButton.innerText = 'Skipping...';
            });
        }
    }

  
    return {
      init: init
    }
  
  }());
